import { render } from "./kumo3.vue?vue&type=template&id=0bc4d1ab&scoped=true"
import script from "./kumo3.vue?vue&type=script&lang=js"
export * from "./kumo3.vue?vue&type=script&lang=js"

import "./kumo3.vue?vue&type=style&index=0&id=0bc4d1ab&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc4d1ab"]])

export default __exports__